import { OGProperties, PageTags } from '../types';
import { RoutesPaths } from '@router/constants';

const title = 'Projects'
const url = window.location.origin + RoutesPaths.PROJECTS

export const projects: PageTags = {
  title: `| ${title}`,
  url: url,
  properties: [
    {
      property: OGProperties.title,
      content: `FireStarter | ${title}`,
    },
    {
      property: OGProperties.description,
      content: 'Take part in FireStarter Projects',
    },
    {
      property: OGProperties.url,
      content: url,
    },
  ]
}
